import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import basisRoutes from "basis/router";
import hfoxRoutes from "hfox/router";
import defiRoutes from "defi/router";
import walletRoutes from "wallet/router";
import tradeRoutes from "trade/router";
import { FusionProject } from "@/types";

Vue.use(VueRouter);

function createFusionRoutes(
  namespace: FusionProject,
  routes: Array<RouteConfig>
) {
  return routes.map(router => {
    return {
      ...router,
      path: "/" + namespace + router.path,
      name: namespace + "-" + router.name
    };
  });
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "wallet"
    },
    ...createFusionRoutes("basis", basisRoutes),
    ...createFusionRoutes("hfox", hfoxRoutes),
    ...createFusionRoutes("defi", defiRoutes),
    ...createFusionRoutes("wallet", walletRoutes),
    ...createFusionRoutes("trade", tradeRoutes)
  ]
});

export default router;
